module.exports = __webpack_public_path__ + "assets/img/rankBg.c418a15a.png";